export default "__VITE_ASSET__BDWyxuEC__"